export const STORAGE_KEYS = {
  FRONT_CANVAS: "tshirt-designer-front",
  BACK_CANVAS: "tshirt-designer-back",
};

const canvasStorageManager = {
  // Save canvas objects
  saveCanvasObjects: (view, canvas) => {
    if (!canvas) return;
    try {
      const storageKey =
        view === "front" ? STORAGE_KEYS.FRONT_CANVAS : STORAGE_KEYS.BACK_CANVAS;

      // Get and save objects - DON'T remove before saving
      const objects = canvas.getObjects().map((obj) => obj.toJSON());

      localStorage.setItem(storageKey, JSON.stringify(objects));

      console.log(`Saved ${objects.length} objects to ${view} canvas`);
    } catch (error) {
      console.error("Error saving canvas objects:", error);
    }
  },

  // Load canvas objects
  loadCanvasObjects: (view) => {
    try {
      const storageKey =
        view === "front" ? STORAGE_KEYS.FRONT_CANVAS : STORAGE_KEYS.BACK_CANVAS;

      const stored = localStorage.getItem(storageKey);
      const objects = stored ? JSON.parse(stored) : null;

      console.log(`Loaded ${objects?.length || 0} objects from ${view} canvas`);

      return objects;
    } catch (error) {
      console.error("Error loading canvas objects:", error);
      return null;
    }
  },

  // Clear stored objects for a specific view
  clearCanvasStorage: (view) => {
    if (view === "all") {
      localStorage.removeItem(STORAGE_KEYS.FRONT_CANVAS);
      localStorage.removeItem(STORAGE_KEYS.BACK_CANVAS);
    } else {
      localStorage.removeItem(
        view === "front" ? STORAGE_KEYS.FRONT_CANVAS : STORAGE_KEYS.BACK_CANVAS
      );
    }
  },
};

export default canvasStorageManager;
